/* global modal */
'use strict'
const alerts = {
	el: {
		btnsAlert: document.querySelectorAll('.js-alert'),
		btnAlertAll: document.querySelector('.js-alert-all'),
		form: document.querySelector('.js-calendar-inputs')
	},

	fxToggleBtn(el, value) {
		el.checked = value
		el.value = value
	},

	fxToggleAlert(event) {
		const target = event.currentTarget,
			container = target.closest('.calendar'),
			alertsContainer = container.querySelector('.calendar__alerts'),
			alertAllBtns = container.querySelectorAll('.js-alert-all'),
			filterBtns = container.querySelectorAll('.js-filter'),
			alertIndividualBtns = container.querySelectorAll('.js-alert')
		let allAlertBtns = []

		allAlertBtns = [...alertAllBtns, ...alertIndividualBtns]

		allAlertBtns.forEach(el => {
			el.disabled = true
		})
		
		//alert all
		if(target.classList.contains('js-alert-all')) {
			let totalAlerts = target.dataset.alerts,
				alertType = target.dataset.type

			for (const btn of alertIndividualBtns) {
				if(alertType === btn.dataset.type) {
					if(target.value === 'true') {
						this.fxToggleBtn(btn, true)
						target.dataset.counter = totalAlerts
					} else {
						this.fxToggleBtn(btn, false)
						target.dataset.counter = 0
					}
				}
			}

			const data = {
				name: alertType,
				isChecked: target.value
			}

			const endpoint = alertsContainer.dataset.endpointAll
			this.fxSendData(data, endpoint, allAlertBtns)

		//alert individual
		} else {
			const alertType = target.dataset.type
			
			for(const btn of alertAllBtns) {
				if(alertType === btn.dataset.type) {
					const alertsCounter = Number(btn.dataset.counter)

					btn.dataset.counter = target.value === 'true' ? alertsCounter + 1 : alertsCounter - 1
					btn.dataset.counter === btn.dataset.alerts ? this.fxToggleBtn(btn, true) : this.fxToggleBtn(btn, false)
				}
			}

			const data = {
				id: target.name,
				isChecked: target.value
			}
			const endpoint = alertsContainer.dataset.endpointIndividual
			this.fxSendData(data, endpoint, allAlertBtns)
		}
	},

	fxSendData(data, endpoint, allAlertBtns) {
		$.ajax({
			url: endpoint,
			type: 'POST',
			data: data,
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			dataType: 'json'
		}).done((data, textStatus, jqXHR) => {
			if(jqXHR.status === 200) {
				
				allAlertBtns.forEach(el => {
					const filterBtn = document.querySelector(`.js-filter[name=${el.dataset.type}]`) && document.querySelector(`.js-filter[name=${el.dataset.type}]`)
					if(filterBtn.checked === false && el.classList.contains('js-alert-all')) {
						el.disabled = true
					} else {
						el.removeAttribute('disabled')
					}				
				})
			}
		}).fail((data, textStatus, jqXHR) => {
			console.log(data, textStatus, jqXHR)
		})
	},

	events() {

	},

	init () {
		if(this.el.btnsAlert.length === 0) return
	}
}

alerts.init()